var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"breadcrumb"},[_c('ul',{staticClass:"breadcrumb__list"},_vm._l((_vm.children),function(child,i){return _c('li',{key:i,staticClass:"breadcrumb__item"},[_c('router-link',{staticClass:"breadcrumb__link",attrs:{"to":child.href}},[_vm._v(_vm._s(child.label))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }